import { Journal } from '../models/journals/journal.ts';
import { JournalSearchParam, JournalSummarySearchParam } from '../models/searchParams/journalSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";
import { GenerateJournalsQuery, GenerateJournalSummaryQuery } from '../models/helpers/generateJournalsQuery.ts';

const JournalsController = {
    getSummary: (searchParam: JournalSummarySearchParam) => {
        let url = `journals/summary${GenerateJournalSummaryQuery(searchParam)}`;
        return ApiClient.get(url);
    },
    get: (tableSearchParam: TableSearchParam, searchParam: JournalSearchParam) => {
        let url = `journals/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateJournalsQuery(searchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`journal/${id}`);
    },
    post: (journal: Journal) => {
        return ApiClient.post('journal', journal);
    },
    put: (journal: Journal) => {
        return ApiClient.put(`journal/${journal.journalID}`, journal);
    },
    delete: (id: number) => {
        return ApiClient.delete(`journal/${id}`)
    }
};
export default JournalsController;